module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aD03AU/tc-custom/9780830847556.jpg?1696024905397",
      "alt": "This image is the cover for the book Forty Days on Being a Seven, Enneagram Daily Reflections"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Forty Days on Being a Seven, Enneagram Daily Reflections\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("What is it like to be an Enneagram Seven?")])]), _vm._v(" "), _c('p', [_vm._v("Adventurer, spiritual leader, and artist Gideon Tsang tackles this question with the signature style of a Seven. Intermixed with stories of travel and making new friends in surprising places, is a commitment to honest self-assessment. Gideon shares how his Enneagram journey has led to personal and spiritual transformation in a series of readings that will delight readers and enlighten readers who want to understand the world of the Seven more fully. Each of the forty readings concludes with an opportunity for further engagement such as a journaling prompt, reflection questions, a written prayer, or a spiritual practice.")]), _vm._v(" "), _c('p', [_vm._v("Any of us can find aspects of ourselves in any of the numbers. The Enneagram is a profound tool for empathy, so whether or not you are a Seven, you will grow from your reading about Sevens and enhance your relationships across the Enneagram spectrum.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gideon Yee Shun Tsang, Suzanne Stabile\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Gideon Yee Shun Tsang is an artist, writer, photographer, and spiritual leader. He was the founding pastor at Vox Veniae in Austin, Texas, where he's been living for the past twenty years. He originally hails from Canada. He can be found meandering the country in his van, bike camping in national forests, or cliff jumping into cenotes.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0